module.exports = __webpack_public_path__ + "img/logos.dd5a078.png";